export const sma = (data, period) => {
  const result = [];
  for (let i = period - 1; i < data.length; i++) {
    let sum = 0;
    for (let j = 0; j < period; j++) sum += data[i - j].close;
    result.push({ time: data[i].time, value: sum / period });
  }
  return result;
};

export const ema = (data, period) => {
  const result = [];
  const multiplier = 2 / (period + 1);
  let prevEma = data.slice(0, period).reduce((s, d) => s + d.close, 0) / period;
  result.push({ time: data[period - 1].time, value: prevEma });
  for (let i = period; i < data.length; i++) {
    prevEma = (data[i].close - prevEma) * multiplier + prevEma;
    result.push({ time: data[i].time, value: prevEma });
  }
  return result;
};

export const rsi = (data, period = 14) => {
  const result = [];
  const changes = [];
  for (let i = 1; i < data.length; i++) changes.push(data[i].close - data[i - 1].close);
  let avgGain = 0, avgLoss = 0;
  for (let i = 0; i < period; i++) {
    if (changes[i] > 0) avgGain += changes[i];
    else avgLoss += Math.abs(changes[i]);
  }
  avgGain /= period; avgLoss /= period;
  result.push({ time: data[period].time, value: 100 - 100 / (1 + avgGain / (avgLoss || 0.001)) });
  for (let i = period; i < changes.length; i++) {
    const gain = changes[i] > 0 ? changes[i] : 0;
    const loss = changes[i] < 0 ? Math.abs(changes[i]) : 0;
    avgGain = (avgGain * (period - 1) + gain) / period;
    avgLoss = (avgLoss * (period - 1) + loss) / period;
    result.push({ time: data[i + 1].time, value: 100 - 100 / (1 + avgGain / (avgLoss || 0.001)) });
  }
  return result;
};

export const bollingerBands = (data, period = 20, stdDev = 2) => {
  const result = [];
  for (let i = period - 1; i < data.length; i++) {
    const slice = data.slice(i - period + 1, i + 1);
    const mean = slice.reduce((s, d) => s + d.close, 0) / period;
    const variance = slice.reduce((s, d) => s + (d.close - mean) ** 2, 0) / period;
    const std = Math.sqrt(variance);
    result.push({
      time: data[i].time,
      upper: mean + stdDev * std,
      middle: mean,
      lower: mean - stdDev * std,
    });
  }
  return result;
};

export const INDICATOR_DEFAULTS = {
  SMA: { periods: [7, 25, 99], color: '#FF9800' },
  EMA: { periods: [12, 26], color: '#E040FB' },
  RSI: { period: 14, color: '#FF6B6B' },
  BollingerBands: { period: 20, stdDev: 2, color: '#4FC3F7' },
};
